import { useState, useEffect, useRef, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module6World.css';
import '../world.css';
import '../../Animations.css';

import Learn from './../../Learn/Learn';
import Practice from './../../Unit1/Module1/Module1Practice';
import Day4Practice from './../Day4Practice/Day4Practice';
import SingingTime from './../../SingingTime/SingingTime';
import Celebrate from './../../Celebrate/Celebrate';
import Surprise from './../../SurpriseVideo/surprise';
import FollowTheBeatModule6 from './../../FollowTheBeat/FollowTheBeatModule6.js';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';
import loading from './../../loading-gif-png-5.gif';

// Constants
const TIMING = {
  BUTTON_AUDIO_DELAY: 700,
  ANIMATION_DELAY: 500,
  KEY_ANIMATION_DELAY: 1000,
  CHEST_SHAKE_DELAY: 1400,
  REWARDS_ANIMATION_DELAY: 1000,
  IOS_VOICE_TIMEOUT: 10000,
};

const COIN_THRESHOLDS = {
  PRIZE_UNLOCK: 100,
  TWO_DIGIT: 10,
  THREE_DIGIT: 100,
};

const STEP_COMPLETED = {
  NOT_STARTED: 'notstarted',
  SINGING_TIME: 'singingtime',
  LEARN: 'learn',
  PRACTICE: 'practice',
  FOLLOW_THE_BEAT: 'followthebeat',
  CELEBRATE: 'celebrate',
  SURPRISE: 'surprise',
};

const MODULE_NAME = 'Greet';
const MODULE_NUM = 'MODULE6';
const SECTION_COMPLETED_THRESHOLD = 4;

const Module6World = () => {
  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module6 } = useSelector((state) => state.module6, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  // Audio refs for iOS compatibility
  const playYouAreAwesomeRef = useRef(null);
  const coinAudioRef = useRef(null);
  const checkSoundRef = useRef(null);
  const rewardsFoundRef = useRef(null);
  const touchButtonRef = useRef(null);
  const buttonSoundRef = useRef(null);
  const playChestOpenRef = useRef(null);
  const playChestShakeRef = useRef(null);
  const displayVoiceRef = useRef(null);
  const prizeRef = useRef(null);
  const presentIconRef = useRef(null);

  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'))
  const background = generateImageUrl('images/Module6Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+2.png');
  const closedChest6 = generateImageUrl('images/Module1Images/Chest_Closed.svg');
  const openChest = generateImageUrl('images/Module1Images/Chest_Open.svg')
  const animal = generateImageUrl('images/Module1Images/Crab.svg')
  const crab = generateImageUrl('images/Module1Images/Crab2.gif')
  const progressbar0 = generateImageUrl('images/Module1Images/ProgressBar_0.svg')
  const progressbar1 = generateImageUrl('images/Module1Images/ProgressBar_1-4.svg')
  const progressbar2 = generateImageUrl('images/Module1Images/ProgressBar_2-4.svg')
  const progressbar3 = generateImageUrl('images/Module1Images/ProgressBar_3-4.svg')
  const progressbarCompleted = generateImageUrl('images/Module1Images/ProgressBar_Completed.svg')
  const coinPick = generateImageUrl('images/Images/AwesomeCoin.png')
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png')
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg')
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png')
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png')
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png')
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png')
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png')
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.svg')
  const keyReward = generateImageUrl('images/Module1Images/Key_Full.png')
  const FishSchoolYellow = generateImageUrl('images/Module6Images/DailyReward_YellowFishes.png')
  const FishSchoolGreen = generateImageUrl('images/Module6Images/DailyReward_GreenFishes.png')
  const Dolphin = generateImageUrl('images/Module6Images/DailyReward_Dolphin.png')
  const Shark = generateImageUrl('images/Module6Images/DailyReward_Shark.png')
  const SeaweedGreen = generateImageUrl('images/Module6Images/DailyReward_SeaweedGreen@3x.png')
  const SeaweedBrown = generateImageUrl('images/Module6Images/DailyReward_SeaweedBrown@3x.png')
  const ClamBlue = generateImageUrl('images/Module6Images/DailyReward_BluePearl.png')
  const ClamPink = generateImageUrl('images/Module6Images/DailyReward_PinkPearl.png')
  const CoralRed = generateImageUrl('images/Module6Images/DailyReward_CoralRed.png')
  const CoralBlue = generateImageUrl('images/Module6Images/DailyReward_CoralBlue.png')
  const SunkenShipGreen = generateImageUrl('images/Module6Images/DailyReward_ShipGreen.png')
  const SunkenShip = generateImageUrl('images/Module6Images/DailyReward_ShipBrown.png')
  const CoralGreen = generateImageUrl('images/Module6Images/DailyReward_CoralGreen.png')
  const CoralPurple = generateImageUrl('images/Module6Images/DailyReward_CoralPurple.png')
  const MermaidBlue = generateImageUrl('images/Module6Images/DailyReward_Mermaid1.png')
  const MermaidRed = generateImageUrl('images/Module6Images/DailyReward_Mermaid2.png')
  const SandCastle = generateImageUrl('images/Module6Images/BigReward_InsideCir_Castle.svg')
  const Treasure = generateImageUrl('images/Module6Images/BigReward_Treasure.svg')
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png')
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png')
  const present = generateImageUrl('images/Images/Gift.png')
  const AfterCelebrateVideo9 = getVideo('appfiles/greet/closing.mp4', login);

  const [chestopen, setChestOpen] = useState(closedChest6);
  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setDisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [singTime, setSingTime] = useState('');
  const [day4Practice, setDay4Practice] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState(false);
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [prize, setPrize] = useState(false);
  const [displayPrize, setDisplayPrize] = useState(false);
  const [checkStep, setCheckStep] = useState('');
  const [userInteracted, setUserInteracted] = useState(false);

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [keyAnimationState, setKeyAnimationState] = useState('');
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);
  const [playChestOpen, setPlayChestOpen] = useState(false);
  const [playChestShake, setPlayChestShake] = useState(false);
  const [chestAnimationState, setChestAnimationState] = useState('');
  const [showCrab, setShowCrab] = useState(false);
  const [crabState, setCrabState] = useState('');
  const [playYouAreAwesome, setPlayYouAreAwesome] = useState(false);
  const [displayFTB, setDisplayFTB] = useState(false);
  const [showReward, setShowReward] = useState(false);

  const [ftbMusic, setFTBMusic] = useState('');
  const [ftbInstruction, setFTBInstruction] = useState('');
  const [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
  const [ftbCount, setFTBCount] = useState('');
  const [ftbTutorial1, setFTBTutorial1] = useState('');
  const [ftbTutorial2, setFTBTutorial2] = useState('');
  const [ftbWT, setFTBWalkThrough] = useState('');

  const [ftbIntro, setFtbIntro] = useState('');
  const [practiceIntro, setPracticeIntro] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [awesomeJob, setAwesomeJob] = useState('');
  const [audioReady, setAudioReady] = useState(false);
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [closingGIF, setClosingGIF] = useState('');
  const [practiceMessage, setPracticeMessage] = useState('');
  const [practiceConversation, setPracticeConversation] = useState('');
  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];

  // ==================== Audio & iOS Compatibility ====================
  // Handle user interaction to enable audio on iOS
  const handleUserInteraction = useCallback(() => {
    setUserInteracted(true);
  }, []);

  // iOS audio compatibility function
  const playAudioWithUserInteraction = useCallback((audioRef, onPlay, onEnded) => {
    if (audioRef && audioRef.current && userInteracted) {
      const playPromise = audioRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            if (onPlay) onPlay();
          })
          .catch((error) => {
            console.log('Audio play failed:', error);
            // Fallback: try to play on next user interaction
            if (onEnded) onEnded();
          });
      }
    }
  }, [userInteracted]);

  // Utility function for delays
  const sleep = useCallback((ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }, []);

  const playButtonAudio = useCallback(() => {
    sleep(TIMING.BUTTON_AUDIO_DELAY).then(() => {
      setButtonSound(true);
    });
  }, []);

  // ==================== Media Loading ====================
  const getGifs = useCallback(() => {
    setAwesomeJob(getVideo('appfiles/greet/greet_awesome_job.gif', login));
    setFTBCount(getVideo('appfiles/greet/countingCrab.gif', login));
  
    setPracticeIntro(getVideo('appfiles/greet/greet_practice_intro.gif', login));
    setLearnIntro(getVideo('appfiles/greet/greet_learn_intro.gif', login));
    setFtbIntro(getVideo('appfiles/greet/ftb_intro.gif', login));
    setCelebrateIntro(getVideo('appfiles/greet/greet_celebrate_intro.gif', login));
  
    setFTBInstruction(getVideo('appfiles/greet/greet_ftb_instructions.mp3', login));
    setFTBInstructionGIF(getVideo('appfiles/greet/ftb_crab_instructions.gif', login));
    setFTBMusic(getVideo('appfiles/greet/FTB_song_counting.m4a', login));
    setClosingGIF(getVideo('appfiles/greet/greet_day_closing.gif', login));
    setPracticeMessage(getVideo('appfiles/greet/greet_special_message.gif', login));
    setPracticeConversation(getVideo('appfiles/greet/practice_watch_conversation.gif', login));
  
    if (!module6.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/greet/ftb_walkthrough_touch_circle.mp3', login));
      setFTBTutorial2(getVideo('appfiles/greet/ftb_walkthrough_count_touch.mp3', login));
      setFTBWalkThrough(getVideo('appfiles/greet/ftb_walkthrough_audio.mp3', login));
    }
  }, []);

  useEffect(() => {
    getGifs();
  }, [getGifs]);

  // ==================== iOS Detection ====================
  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  useEffect(() => {
    let timer;
    if (displayVoice && isIOS()) {
      timer = setTimeout(() => {
        setAudioReady(false);
        setShowCrab(false);
        setDisplayVoice(false);
      }, TIMING.IOS_VOICE_TIMEOUT);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [displayVoice]);


  // iOS audio compatibility - trigger audio playback when state changes
  useEffect(() => {
    if (playYouAreAwesome && playYouAreAwesomeRef.current) {
      playAudioWithUserInteraction(
        playYouAreAwesomeRef,
        () => setAudioReady(true),
        () => module6.currentday === 8
          ? closeDay8Video()
          : navigate('/greet/navigation')
      );
    }
  }, [playYouAreAwesome, playAudioWithUserInteraction, module6.currentday, navigate]);

  useEffect(() => {
    if (coinAudio && coinAudioRef.current) {
      playAudioWithUserInteraction(
        coinAudioRef,
        null,
        () => {
          dispatch({ type: 'MODULE6_SET_COIN', payload: module6.coins + 1 });
          setCoinAudio(false);
          setCoinAnimationState('bounceIcons');
          setCoinIcon(false);
          playButtonAudio();
        }
      );
    }
  }, [coinAudio, playAudioWithUserInteraction, dispatch, module6.coins, playButtonAudio]);

  useEffect(() => {
    if (checkSound && checkSoundRef.current) {
      playAudioWithUserInteraction(
        checkSoundRef,
        null,
        () => setCheckSound(false)
      );
    }
  }, [checkSound, playAudioWithUserInteraction]);

  useEffect(() => {
    if (rewardsFound && rewardsFoundRef.current) {
      playAudioWithUserInteraction(rewardsFoundRef);
    }
  }, [rewardsFound, playAudioWithUserInteraction]);

  useEffect(() => {
    if (touchButton && touchButtonRef.current) {
      playAudioWithUserInteraction(
        touchButtonRef,
        null,
        () => setTouchButton(false)
      );
    }
  }, [touchButton, playAudioWithUserInteraction]);

  useEffect(() => {
    if (buttonSound && buttonSoundRef.current) {
      playAudioWithUserInteraction(
        buttonSoundRef,
        null,
        () => setButtonSound(false)
      );
    }
  }, [buttonSound, playAudioWithUserInteraction]);

  useEffect(() => {
    if (playChestOpen && playChestOpenRef.current) {
      playAudioWithUserInteraction(playChestOpenRef);
    }
  }, [playChestOpen, playAudioWithUserInteraction]);

  useEffect(() => {
    if (playChestShake && playChestShakeRef.current) {
      playAudioWithUserInteraction(playChestShakeRef);
    }
  }, [playChestShake, playAudioWithUserInteraction]);

  useEffect(() => {
    if (prize && prizeRef.current) {
      playAudioWithUserInteraction(prizeRef);
    }
  }, [prize, playAudioWithUserInteraction]);

  useEffect(() => {
    if (presentIcon && presentIconRef.current) {
      playAudioWithUserInteraction(presentIconRef);
    }
  }, [presentIcon, playAudioWithUserInteraction]);

  // ==================== Database & Game Logic ====================
  const createGameDetails = useCallback(
    (flag, reward, coin) => {
      const game_detail = module6.game_details;
      if (flag) {
        const flags = { flag, lastUpdated: new Date().toJSON() };
        game_detail.moduleFlags.push(flags);
      }
      if (coin >= 0) {
        game_detail.tokens_earned = coin;
      }
      if (reward) {
        const dailyRewards = [];
        for (const key in module6.rewards) {
          if (module6.rewards[key] === true) {
            const rewards = { type: key, x_multiplier: 1, y_multiplier: 1 };
            dailyRewards.push(rewards);
          }
        }
        game_detail.dailyRewards = dailyRewards;
      }
      dispatch({ type: 'MODULE6_SET_GameDetials', payload: game_detail });
    },
    [dispatch, module6.game_details, module6.rewards]
  );

  const updateProgress = async () => {
    const payload = {
      body: {
        id: login.studentid,
        module: MODULE_NAME,
        day_completed: module6.currentday,
        time_completed: new Date().toDateString(),
      },
    };
    try {
      await API.put('TIR', '/v3/student/progress', payload);
    } catch (error) {
      // Progress update failed silently
    }
  };

  useEffect(() => {
    if (
      (module6.reviewIcon === true || login.grade === 'Teacher Mode') &&
      module6.sectionCompleted === SECTION_COMPLETED_THRESHOLD
    ) {
      updateProgress();
      module6.sectionCompleted = 0;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [module6.sectionCompleted, module6.reviewIcon, login.grade]);

  const updateDB = async () => {
    const modulePayload = {
      body: {
        id: module6.moduleID,
        day_completed: module6.day_completed,
        step_completed: module6.stepCompleted,
        game_details: JSON.stringify(module6.game_details),
      },
    };

    try {
      await API.put('TIR', '/v3/student/module', modulePayload);
      if (displayGreenButton) {
        setAnimalVoice(null);
        setCrabState(closingGIF);
        setShowCrab(true);
        setPlayYouAreAwesome(true);
        setDisplayGreenButton(false);
        setDisplayReward(false);
      }
    } catch (error) {
      const criticalSteps = [
        STEP_COMPLETED.NOT_STARTED,
        STEP_COMPLETED.LEARN,
        STEP_COMPLETED.PRACTICE,
        STEP_COMPLETED.CELEBRATE,
        STEP_COMPLETED.FOLLOW_THE_BEAT,
      ];
      if (criticalSteps.includes(module6.stepCompleted)) {
        window.alert('Connection is lost. Please login again.');
        dispatch({ type: 'CLEAR' });
        Auth.signOut();
        navigate('/');
      }
    }

    // Update student's current module
    const studentPayload = {
      body: {
        id: login.studentid,
        current_module: MODULE_NAME,
      },
    };
    try {
      await API.put('TIR', '/v3/student', studentPayload);
    } catch (error) {
      // Student update failed silently
    }
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module6.stepCompleted]);

  useEffect(() => {
    if (module6.coins >= COIN_THRESHOLDS.PRIZE_UNLOCK) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module6.coins);
      updateDB();
    }
  }, [module6.coins]);

  // ==================== UI Handlers ====================
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  // ==================== Progress & Step Management ====================
  useEffect(() => {
    if (module6.currentday <= module6.day_completed || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE6_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE6_SET_KEY', payload: 4 });
      if (module6.currentday === 4 || module6.currentday === 8) {
        dispatch({ type: 'MODULE6_SET_KEY', payload: 5 });
      }
    } else {
      if (module6.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE6_TOGGLE_REVIEW_ICON', payload: false });
      if (module6.currentday === 4 && module6.day_completed === 3) {
        if (module6.stepCompleted === STEP_COMPLETED.NOT_STARTED) {
          dispatch({ type: 'MODULE6_SET_KEY', payload: 0 });
        } else if (module6.stepCompleted === STEP_COMPLETED.SINGING_TIME) {
          dispatch({ type: 'MODULE6_SET_KEY', payload: 1 });
        } else if (module6.stepCompleted === STEP_COMPLETED.LEARN) {
          dispatch({ type: 'MODULE6_SET_KEY', payload: 2 });
        } else if (module6.stepCompleted === STEP_COMPLETED.PRACTICE) {
          dispatch({ type: 'MODULE6_SET_KEY', payload: 3 });
        } else if (module6.stepCompleted === STEP_COMPLETED.FOLLOW_THE_BEAT) {
          dispatch({ type: 'MODULE6_SET_KEY', payload: 4 });
        } else if (module6.stepCompleted === STEP_COMPLETED.CELEBRATE) {
          setKeyIcon(true);
          dispatch({ type: 'MODULE6_SET_KEY', payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module6.stepCompleted === STEP_COMPLETED.NOT_STARTED) {
          dispatch({ type: 'MODULE6_SET_KEY', payload: 0 });
        } else if (module6.stepCompleted === STEP_COMPLETED.LEARN) {
          dispatch({ type: 'MODULE6_SET_KEY', payload: 1 });
        } else if (module6.stepCompleted === STEP_COMPLETED.PRACTICE) {
          dispatch({ type: 'MODULE6_SET_KEY', payload: 2 });
        } else if (module6.stepCompleted === STEP_COMPLETED.FOLLOW_THE_BEAT) {
          dispatch({ type: 'MODULE6_SET_KEY', payload: 3 });
        } else if (module6.stepCompleted === STEP_COMPLETED.CELEBRATE) {
          if (module6.currentday === 8 && module6.day_completed === 7) {
            dispatch({ type: 'MODULE6_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE6_SET_KEY', payload: 4 });
          }
        } else if (module6.stepCompleted === STEP_COMPLETED.SURPRISE) {
          dispatch({ type: 'MODULE6_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module6.stepCompleted]);

  // ==================== Reward & Prize Functions ====================
  const selectReward = () => {
    return (
      <>
        <div className='rewards'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                handleUserInteraction();
                dispatch({
                  type: `MODULE6_SET_REWARD${module6.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE6_SET_REWARD${module6.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                handleUserInteraction();
                dispatch({
                  type: `MODULE6_SET_REWARD${module6.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE6_SET_REWARD${module6.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                handleUserInteraction();
                setCheckSound(true);
                updateProgress();
                sleep(TIMING.ANIMATION_DELAY).then(() => {
                  createGameDetails(false, true, module6.coins);
                  if (login.grade === 'Teacher Mode' || login.grade === 'Free Play') {
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE6_SET_DAY_UNLOCK${module6.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE6_SET_dayCompleted',
                    payload: module6.currentday === 8 ? 9 : module6.currentday,
                  });
                  dispatch({
                    type: 'MODULE6_SET_stepCompleted',
                    payload: STEP_COMPLETED.NOT_STARTED,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={SandCastle}
              alt=''
              onClick={() => {
                handleUserInteraction();
                touchSound.load()
                dispatch({ type: `MODULE6_SET_PRIZE1`, payload: true });
                dispatch({ type: `MODULE6_SET_PRIZE2`, payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                touchSound.play()
                setDisplayGreenButton(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={Treasure}
              alt=''
              onClick={() => {
                handleUserInteraction();
                touchSound.load()
                dispatch({ type: `MODULE6_SET_PRIZE2`, payload: true });
                dispatch({ type: `MODULE6_SET_PRIZE1`, payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                touchSound.play()
                setDisplayGreenButton(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                handleUserInteraction();
                setDisplayPrize(false);
                setCheckSound(true);
                sleep(TIMING.ANIMATION_DELAY).then(() => {
                  setDisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE6_SET_COIN',
                    payload: module6.coins - COIN_THRESHOLDS.PRIZE_UNLOCK,
                  });
                  setChestOpen(closedChest6);
                  setPlayChestOpen(false);
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module6.currentday) {
      case 1:
        setRewardOption1(FishSchoolYellow);
        setRewardOption2(FishSchoolGreen);
        break;
      case 2:
        setRewardOption1(Dolphin);
        setRewardOption2(Shark);
        break;
      case 3:
        setRewardOption1(SeaweedGreen);
        setRewardOption2(SeaweedBrown);
        break;
      case 4:
        setRewardOption1(ClamBlue);
        setRewardOption2(ClamPink);
        break;
      case 5:
        setRewardOption1(CoralRed);
        setRewardOption2(CoralBlue);
        break;
      case 6:
        setRewardOption1(SunkenShipGreen);
        setRewardOption2(SunkenShip);
        break;
      case 7:
        setRewardOption1(CoralGreen);
        setRewardOption2(CoralPurple);
        break;
      case 8:
        setRewardOption1(MermaidBlue);
        setRewardOption2(MermaidRed);
        break;
      default:
        break;
    }
  }, [
    keyIcon,
    ClamBlue,
    ClamPink,
    CoralBlue,
    CoralGreen,
    CoralPurple,
    CoralRed,
    Dolphin,
    FishSchoolGreen,
    FishSchoolYellow,
    MermaidBlue,
    MermaidRed,
    SeaweedBrown,
    SeaweedGreen,
    Shark,
    SunkenShip,
    SunkenShipGreen,
    module6.currentday,
  ]);

  // ==================== Module Opening Functions ====================
  const displayReview = () => {
    if (module6.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                handleUserInteraction();
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                handleUserInteraction();
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                handleUserInteraction();
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                handleUserInteraction();
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                handleUserInteraction();
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                handleUserInteraction();
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                handleUserInteraction();
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                handleUserInteraction();
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                handleUserInteraction();
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/greet/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module6.currentday === 4) {
              dispatch({ type: 'MODULE6_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module6.day_completed === 9) {
              navigate('/greet/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song = getVideo('appfiles/greet/greet_sing_along.m4a', login);
    let video = getVideo(`appfiles/greet/learn_video.mp4`, login);
    switch (module6.currentday) {
      case 1:
        setLearn(
          <Learn
            video={getVideo('appfiles/greet/learn_day_1.mp4', login)}
            songVideo={video}
            closingVideo={getVideo('appfiles/greet/learn_day1_part2.mp4', login)}
            destiny='/greet'
            song={song}
            back='/greet'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed={`${MODULE_NUM}_SET_stepCompleted`}
            module={module6}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video={getVideo('appfiles/greet/learn_day_2.mp4', login)}
            songVideo={video}
            closingVideo={getVideo('appfiles/greet/learn_day2_part2.mp4', login)}
            destiny='/greet'
            song={song}
            back='/greet'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed={`${MODULE_NUM}_SET_stepCompleted`}
            module={module6}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video={getVideo('appfiles/greet/learn_day_3.mp4', login)}
            songVideo={video}
            closingVideo={getVideo('appfiles/greet/learn_day3_part2.mp4', login)}
            destiny='/greet'
            song={song}
            back='/greet'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed={`${MODULE_NUM}_SET_stepCompleted`}
            module={module6}
          />
        );
        break;
      default:
        setAnimalVoice(getVideo('appfiles/greet/greet_learn_intro.mp3', login));
        // setDisplayVoice(true)
        setCrabState(learnIntro);
        setShowCrab(true);
        await GetUserVideo(`userfiles/${module6.StudentID}/greet_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module6.currentday-4]}/greet_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                  setLearn(
                    <Learn
                      songVideo={video}
                      destiny='/greet'
                      song={data}
                      back='/greet'
                      background={background}
                      setDisplayLearn={setDisplayLearn}
                      step_completed='MODULE6_SET_stepCompleted'
                      module={module6}
                      instrumental={getVideo('appfiles/greet/greet_instrumental_with_octopus.m4a', login)}
                      influencerVideo={influencerVideo}
                    />
                  );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/greet'
                    song={song}
                    back='/greet'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE6_SET_stepCompleted'
                    module={module6}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    const text = [
      'Say, "Hi!"',
      'Say, "Hello!"',
      'Say, "Good morning, Mrs. Johnson!"',
      'Say, "Good afternoon!"',
      'Say, "It is good to see you!"',
    ];
    switch (module6.currentday) {
      case 1:
        setDisplayPractice(true);
        break;
      case 2:
        setDisplayPractice(true);
        break;
      case 3:
        setDisplayPractice(true);
        break;
      default:
        const introVideo = getVideo('appfiles/greet/practice_instructions.mp4', login);
        let greeting = getVideo(`appfiles/greet/greet_greeting_${module6.currentday + 1}.mp4`, login)
        setAnimalVoice(getVideo('appfiles/greet/greet_practice_intro.mp3', login));
        // setDisplayVoice(true)
        setCrabState(practiceIntro);
        setShowCrab(true);
        await GetUserVideo(`influencers/${influencers[module6.currentday-4]}/greet_video_message.mp4`).then((influencerVideo) => {
          setDay4Practice(
            <Day4Practice
              module={module6}
              celebrateVideo={introVideo}
              background={background}
              question={greeting}
              influencerVideo={influencerVideo}
              text={text[module6.currentday - 4]}
              voice1={getVideo(`appfiles/greet/greet_practice_record_${module6.currentday + 1}.mp3`, login)}
              voice2={getVideo('appfiles/greet/greet_practice_special_message.mp3', login)}
              voice3={getVideo('appfiles/greet/greet_practice_watch_conversation.mp3', login)}
              voice4={getVideo('appfiles/eye_contact/crab_awesome_job.mp3', login)}
              animate2={practiceMessage}
              animate3={practiceConversation}
              animate4={awesomeJob}
              name={`greet_practice_video_${module6.currentday + 1}.mp4`}
              greeting={greeting}
              animal={animal}
              setDisplayDay4Practice={setDisplayDay4Practice}
              moduleNum={MODULE_NUM}
            />
          );
        });
        setDisplayDay4Practice(true);
        break;
    }
  };

  const openFTB = async () => {
    switch (module6.currentday) {
      case 1:
        break;
      case 2:
        break;
      case 3:
        break;
      default:
        setCrabState(ftbIntro);
        setAnimalVoice(getVideo('appfiles/greet/greet_ftb_intro.mp3', login));
        // setDisplayVoice(true)
        setShowCrab(true);
        break;
    }
    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = getVideo('appfiles/greet/celebrate_day_1.mp4', login);
    const celebrateVideo2 = getVideo('appfiles/greet/celebrate_day_2.mp4', login);
    const celebrateVideo3 = getVideo('appfiles/greet/celebrate_day_3.mp4', login);

    switch (module6.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module6}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module6}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module6}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      default:
        setAnimalVoice(await getVideo('appfiles/greet/greet_celebrate_intro.mp3', login));
        setCrabState(celebrateIntro);
        setShowCrab(true);
        await GetUserVideo(`influencers/${influencers[module6.currentday-4]}/greet_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              module={module6}
              background={background}
              voice1={getVideo('appfiles/greet/greet_celebrate_record_awesome.mp3', login)}
              voice2={getVideo('appfiles/greet/greet_celebrate_say_thanks.mp3', login)}
              voice3={getVideo('appfiles/eye_contact/crab_awesome_job.mp3', login)}
              text={'Record yourself in an excited voice and say, "I am awesome!"'}
              name={`greet_celebration_surprise_${module6.currentday + 1}.mp4`}
              influencerVideo={influencerVideo}
              animation={awesomeJob}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={MODULE_NUM}
            />
          );
        });
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = getVideo('appfiles/greet/singing_time.mp4', login);
    let singingMusic = await getVideo('appfiles/greet/greet_sing_along.m4a', login);
    let instrumental = await getVideo('appfiles/greet/greet_instrumental.m4a', login);
    let noteVideo = await getVideo('appfiles/greet/greet_student_notes.mp4', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module6}
        moduleNum={MODULE_NUM}
        name='greet'
        instrumental={instrumental}
        instrumentalURL={'appfiles/greet/greet_instrumental_with_octopus.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `influencers/${login.influencerid}/greet_affirmation.mp4`,
      },
      {
        video: `userfiles/${module6.StudentID}/greet_celebration_surprise_5.mp4`,
      },
      {
        video: 'appfiles/greet/greet_greeting_5.mp4',
      },
      {
        video: `userfiles/${module6.StudentID}/greet_practice_video_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/greet_video_message.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/greet_affirmation.mp4`,
      },
      {
        video: `userfiles/${module6.StudentID}/greet_celebration_surprise_6.mp4`,
      },
      {
        video: 'appfiles/greet/greet_greeting_6.mp4',
      },
      {
        video: `userfiles/${module6.StudentID}/greet_practice_video_6.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/greet_video_message.mp4`,
      },
      {
        video: `influencers/${login.influencerid4}/greet_affirmation.mp4`,
      },
      {
        video: `userfiles/${module6.StudentID}/greet_celebration_surprise_7.mp4`,
      },
    ];

    for (let i = 0; i < usePhoto.length; i++) {
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }

    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/greet/greet_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });

    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  // ==================== Animation Functions ====================
  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  const keyAnimation = () => {
    setKeyAnimationState('fade-out');
    sleep(TIMING.KEY_ANIMATION_DELAY).then(() => {
      chestShakeAnimation();
    });
  };

  const chestShakeAnimation = () => {
    setChestAnimationState('shakeChest');
    setPlayChestShake(true);
    sleep(TIMING.CHEST_SHAKE_DELAY).then(() => {
      setKeyIcon(false);
      setChestOpen(openChest);
      setPlayChestOpen(true);
      rewardsMovingAnimation();
    });
  };

  const rewardsMovingAnimation = () => {
    sleep(TIMING.REWARDS_ANIMATION_DELAY).then(() => {
      setDisplayReward(true);
    });
  };

  const closeDay8Video = () => {
    setIntroVideo(AfterCelebrateVideo9);
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setShowCrab(false);
  };

  return (
    <>
      {playYouAreAwesome && (
        <audio
          ref={playYouAreAwesomeRef}
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() =>
            module6.currentday === 8
              ? closeDay8Video()
              : navigate('/greet/navigation')
          }
        >
          <source
            src={
              generateImageUrl('media/Module6/greet_day_finished.mp3')
            }
          ></source>
        </audio>
      )}

      {coinAudio && (
        <audio
          ref={coinAudioRef}
          onEnded={() => {
            dispatch({ type: 'MODULE6_SET_COIN', payload: module6.coins + 1 });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {checkSound && (
        <audio
          ref={checkSoundRef}
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {rewardsFound && (
        <audio ref={rewardsFoundRef}>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          ref={touchButtonRef}
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          ref={buttonSoundRef}
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {playChestOpen && (
        <audio ref={playChestOpenRef}>
          <source
            src={
              generateImageUrl('media/Module1Videos/chest_open_items_out.mp3')
            }
          ></source>
        </audio>
      )}

      {playChestShake && (
        <audio ref={playChestShakeRef}>
          <source
            src={
              generateImageUrl('media/Module1Videos/chest_shake.mp3')
            }
          ></source>
        </audio>
      )}

      {displayVoice && (
        <audio
          autoPlay
          ref={displayVoiceRef}
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            // setCrabState(crab)
            setAudioReady(false);
            setShowCrab(false);
            setDisplayVoice(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {displayIntroVideo && introduction()}
      {!showCrab && displayLearn && learn}
      {!showCrab && displayDay4Practice && day4Practice}
      {displayPractice && (
        <Practice
          setDisplayPractice={setDisplayPractice}
          background={background}
          stepComplete={`${MODULE_NUM}_SET_stepCompleted`}
          module={module6}
          world2={true}
        />
      )}
      {!showCrab && displayFTB && (
        <FollowTheBeatModule6
          setDisplayFTB={setDisplayFTB}
          awesomeJob={awesomeJob}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={`${MODULE_NUM}_SET_stepCompleted`}
          module={module6}
          score={'ftb_greet'}
        />
      )}
      {displaySingingTime && singTime}
      {!showCrab && displayCelebrate && celebrate}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        showCrab) && (
        <div
          className='greetWorldBody'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module6Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+2.png')
            })`,
          }}
          onClick={handleUserInteraction}
          onTouchStart={handleUserInteraction}
        >
          <nav className='nav'>
            <div className='navigation'>
              <img
                className='logoutBtn'
                src={logoutBtn}
                alt='Logout Button'
                onClick={(e) => {
                  handleUserInteraction();
                  togglePopup();
                }}
              />
              <img
                className='JourneyBlueImage'
                src={journeyImage}
                alt='Navigation blue world'
                onClick={() => {
                  handleUserInteraction();
                  navigate('/greet/navigation');
                }}
              />
            </div>
            <div className='scoreBar'>
              <img
                className='scoreKey'
                src={coinBar}
                alt='crab Icon'
              />
              {module6.coins < COIN_THRESHOLDS.TWO_DIGIT && (
                <h5 className='scoretext1'>{module6.coins}</h5>
              )}
              {module6.coins >= COIN_THRESHOLDS.TWO_DIGIT && module6.coins < COIN_THRESHOLDS.THREE_DIGIT && (
                <h5 className='scoretext10'>{module6.coins}</h5>
              )}
              {module6.coins >= COIN_THRESHOLDS.THREE_DIGIT && (
                <h5 className='scoretext100'>{module6.coins}</h5>
              )}
              <p className='scoretext'>{COIN_THRESHOLDS.PRIZE_UNLOCK}</p>
            </div>

            {module6.currentday === 4 || module6.currentday === 8 ? (
              <div className='progressBar'>
                <img
                  className='progressKey'
                  src={keys5[module6.keys]}
                  alt='crab Icon'
                />
                <h3 className='progresstext'>{module6.keys}/5</h3>
              </div>
            ) : (
              <div className='progressBar'>
                <img
                  className='progressKey'
                  src={keys4[module6.keys]}
                  alt='crab Icon'
                />
                <h3 className='progresstext'>{module6.keys}/4</h3>
              </div>
            )}
          </nav>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}

          {prize && (
            <audio ref={prizeRef}>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                handleUserInteraction();
                setPrize(false);
                setChestAnimationState('shakeChest');
                setPlayChestShake(true);
                sleep(TIMING.CHEST_SHAKE_DELAY).then(() => {
                  setChestOpen(openChest);
                  setPlayChestOpen(true);
                  sleep(TIMING.REWARDS_ANIMATION_DELAY).then(() => {
                    setDisplayPrize(true);
                  });
                });
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                handleUserInteraction();
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {displayPrize && openPrize()}

          <img
            className='animateCrab'
            src={crab}
            alt='crab Icon'
          />
          {showCrab && !audioReady && <img id='loading' src={loading} alt='' />}
          {showCrab && (
            <img
              alt=''
              className='animateCrab'
              style={audioReady ? {} : { display: 'none' }}
              src={crabState}
              onLoad={() => setDisplayVoice(true)}
              onError={() => setShowCrab(false)}
            ></img>
          )}
          <img
            className='closedChest6'
            src={chestopen}
            id={chestAnimationState}
            alt='closed Chest Icon'
          />

          {!showCrab && !module6.reviewIcon && !coinIcon && !displayPrize && (
            <div className='actionBtnDiv'>
              {module6.currentday === 4 &&
                module6.stepCompleted === STEP_COMPLETED.NOT_STARTED && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={SingingTimeIcon}
                    alt='learn button'
                    onClick={() => {
                      handleUserInteraction();
                      setTouchButton(true);
                      sleep(TIMING.ANIMATION_DELAY).then(() => {
                        displaySinging();
                        setCheckStep(STEP_COMPLETED.SINGING_TIME);
                      });
                    }}
                  />
                )}
              {module6.currentday !== 4 &&
                module6.stepCompleted === STEP_COMPLETED.NOT_STARTED && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={learnBtn}
                    alt='learn button'
                    onClick={() => {
                      handleUserInteraction();
                      setTouchButton(true);
                      sleep(TIMING.ANIMATION_DELAY).then(() => {
                        openLearn();
                        setCheckStep(STEP_COMPLETED.LEARN);
                      });
                    }}
                  />
                )}

              {module6.stepCompleted === STEP_COMPLETED.LEARN && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={practiceBtn}
                  alt='practice button'
                  onClick={() => {
                    handleUserInteraction();
                    touchSound.play();
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openPractice();
                      setCheckStep(STEP_COMPLETED.PRACTICE);
                    });
                  }}
                />
              )}
              {module6.stepCompleted === STEP_COMPLETED.PRACTICE && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={ftbBtn}
                  alt='celebrate button'
                  onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openFTB();
                      setCheckStep(STEP_COMPLETED.FOLLOW_THE_BEAT);
                    });
                  }}
                />
              )}
              {module6.stepCompleted === STEP_COMPLETED.FOLLOW_THE_BEAT && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={celebrateBtn}
                  alt='celebrate button'
                  onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openCelebrate();
                      setCheckStep(STEP_COMPLETED.CELEBRATE);
                    });
                  }}
                />
              )}
              {module6.stepCompleted === STEP_COMPLETED.SINGING_TIME && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={learnBtn}
                  alt='singing button'
                  onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openLearn();
                      setCheckStep(STEP_COMPLETED.LEARN);
                    });
                  }}
                />
              )}
            </div>
          )}

          {!displayVoice && coinIcon && !displayPrize && (
            <div className='actionBtnDiv'>
              {module6.reviewIcon === false && (
                <img
                  id={coinAnimationState}
                  src={coinPick}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                    zIndex: 10,
                  }}
                  onClick={() => {
                    handleUserInteraction();
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!displayPrize &&
            !showCrab &&
            !displayReward &&
             (
              <div className='actionBtnDiv'>
                {module6.reviewIcon && ( 
                <img
                  src={reviewBtn}
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  alt='review button'
                  onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      setReviewIcon(!reviewIcon);
                    });
                  }}
                />)}
                {showReward && (
                  <img
                    src={rewardBtn}
                    className='actionBtn4'
                    alt='review button'
                    onClick={() => {
                      handleUserInteraction();
                      setTouchButton(true);
                      sleep(TIMING.ANIMATION_DELAY).then(() => {
                        keyAnimation();
                      });
                    }}
                />)}
                {module6.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {keyIcon && !coinIcon && !displayPrize && (
            <img
              src={keyReward}
              id={keyAnimationState}
              style={{
                width: '150px',
                height: '50px',
                marginLeft: '-75px',
                zIndex: 10,
              }}
              className='rewardsIcon'
              alt='reward key'
              onClick={() => {
                handleUserInteraction();
                keyAnimation();
              }}
            />
          )}
          {displayReward && selectReward()}

          {!displayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                handleUserInteraction();
                playSurpriseVideo();
              }}
            />
          )}
          {!displayPrize && !coinIcon && presentIcon && (
            <audio ref={presentIconRef}>
              <source src={presentSound}></source>
            </audio>
          )}

          {module6.rewards.ClamPink && (
            <img className='ClamPink' src={ClamPink} alt='' />
          )}
          {module6.rewards.ClamBlue && (
            <img className='ClamBlue' src={ClamBlue} alt='' />
          )}
          {module6.rewards.SunkenShip && (
            <img className='SunkenShip' src={SunkenShip} alt='' />
          )}
          {module6.rewards.Dolphin && (
            <img className='Dolphin' src={Dolphin} alt='' />
          )}
          {module6.rewards.Shark && (
            <img className='Shark' src={Shark} alt='' />
          )}
          {module6.rewards.MermaidBlue && (
            <img className='MermaidBlue' src={MermaidBlue} alt='' />
          )}
          {module6.rewards.SunkenShipGreen && (
            <img className='SunkenShipGreen' src={SunkenShipGreen} alt='' />
          )}
          {module6.rewards.CoralPurple && (
            <img className='CoralPurple' src={CoralPurple} alt='' />
          )}
          {module6.rewards.CoralBlue && (
            <img className='CoralBlue' src={CoralBlue} alt='' />
          )}
          {module6.rewards.MermaidRed && (
            <img className='MermaidRed' src={MermaidRed} alt='' />
          )}
          {module6.rewards.CoralGreen && (
            <img className='CoralGreen' src={CoralGreen} alt='' />
          )}
          {module6.rewards.FishSchoolGreen && (
            <img className='FishSchoolGreen' src={FishSchoolGreen} alt='' />
          )}
          {module6.rewards.FishSchoolYellow && (
            <img className='FishSchoolYellow' src={FishSchoolYellow} alt='' />
          )}
          {module6.rewards.SeaweedGreen && (
            <img className='SeaweedGreen' src={SeaweedGreen} alt='' />
          )}
          {module6.rewards.SeaweedBrown && (
            <img className='SeaweedBrown' src={SeaweedBrown} alt='' />
          )}
          {module6.rewards.CoralRed && (
            <img className='CoralRed' src={CoralRed} alt='' />
          )}
          {module6.rewards.SandCastle && (
            <img className='SandCastle1' src={SandCastle} alt='' />
          )}
          {module6.rewards.Treasure && (
            <img className='Treasure' src={Treasure} alt='' />
          )}
        </div>
      )}
    </>
  );
};
export default Module6World;
